const REORG_OVERLAP_BLOCKS = 8n

export const getDivineManagerCatchupStartBlock = (archivedThroughBlock: bigint) =>
  archivedThroughBlock > REORG_OVERLAP_BLOCKS ? archivedThroughBlock - REORG_OVERLAP_BLOCKS : 0n
